import Icon1 from "@assets/icons/Icon";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";
import SideBarButton from "./SideBarButton";
import { useEffect, useState } from "react";
import { navigateTo } from "context/navigation.service";
import { useDataStore } from "@store/user_org";
import { useAuthStore } from "@store/auth";
import DropButton from "@components/ui/buttons/DropButton";
import SideMenuButton from "./SideMenuButton";
import { colors } from "sexy";
import { isGUEST } from "@helpers/accessHelpers";

export default function SettingBar({
  page,
  setPage,
}: {
  page: string;
  setPage: (page: string) => void;
}) {
  const [settings_open, setSettingsOpen] = useState<any>(false);
  const [isVisible, setIsVisible] = useState(false);
  const userData = useDataStore((state) => state.userData);
  const orgData = useDataStore((state) => state.orgData);
  const logout = useAuthStore((state) => state.logout);
  const isGuest = isGUEST(userData);
  useEffect(() => {
    if (settings_open) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [settings_open]);

  return (
    <div className="w-64 min-w-64 h-screen  justify-start pt-10 pl-2 border-r-1 flex flex-col">
      <div className="flex flex-col pl-2">
        <div className=" ml-3 font-semibold text-hx ">Paramètres</div>
        <div className="flex flex-col mt-6 mr-6">
          <SideBarButton
            label="Compte"
            name="user"
            highlighted={page === "account"}
            onClick={() => navigateTo({ route: "/settings?page=account" })}
          />
          {!isGuest && (
            <>
              <SideBarButton
                label="Entreprise"
                name="business"
                highlighted={page === "company"}
                onClick={() => navigateTo({ route: "/settings?page=company" })}
              />
              <SideBarButton
                label="Equipe"
                name="users"
                highlighted={page === "team"}
                onClick={() => navigateTo({ route: "/settings?page=team" })}
              />
              <SideBarButton
                label="Modèles emails"
                name="email"
                highlighted={page === "email-templates"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=email-templates" })
                }
              />
              <SideBarButton
                label="Modèles projets"
                name="cube"
                highlighted={page === "project-templates"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=project-templates" })
                }
              />
              <SideBarButton
                label="Modèles formulaires"
                name="form"
                highlighted={page === "form-templates"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=form-templates" })
                }
              />
              <SideBarButton
                label="Bibliothèque"
                name="bookshelf"
                highlighted={page === "library"}
                onClick={() => navigateTo({ route: "/settings?page=library" })}
              />
              <SideBarButton
                label="Designs emails"
                name="design"
                highlighted={page === "email-designs"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=email-designs" })
                }
              />
              <div className="mt-4 mb-1 ml-1 text-h4 text-neutral-400">
                Debug
              </div>
              <SideBarButton
                label="Sync operations"
                name="sync"
                highlighted={page === "sync-operations"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=sync-operations" })
                }
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
